import { Box, Typography } from '@mui/material';

import { LoadingButtonNavigation, PaddingBox } from '~components/atoms/custom';
import { LOGIN_PATH } from '~configs';
import { useForgotPasswordContext } from '~providers';

export const EmailSentSuccessPage: React.FC = () => {
  const { requestedEmail } = useForgotPasswordContext();

  return (
    <PaddingBox
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={3}
      width="100%"
      height="100vh"
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={1}
        width="100%"
        flex={1}
      >
        <Typography variant="h6" fontWeight={600}>
          Check your inbox
        </Typography>
        <Typography color="text.placeholder" textAlign="center">
          We sent an email with password reset instructions to
        </Typography>
        <Typography color="text.highlight" textAlign="center">
          {requestedEmail}
        </Typography>
      </Box>

      {/* Return to login Button */}
      <LoadingButtonNavigation path={LOGIN_PATH}>
        <Typography variant="body2" fontWeight={500}>
          Return to login
        </Typography>
      </LoadingButtonNavigation>
    </PaddingBox>
  );
};
